import { ITerminology } from 'shared/models/Terminology'

export const staticTerminology: ITerminology = {
  Beboer: 'Bruker',
  Beboere: 'Brukere',
  Eier: 'Andelseier',
  Eiere: 'Andelseiere',
  Enhet: 'Andel',
  Enheter: 'Andeler',
  Generalforsamling: 'Generalforsamling',
  Leietaker: 'Leietaker',
  Leietakere: 'Leietakere',
  Medboer: 'Medboer',
  Medboere: 'Medboere',
  Selskap: 'Borettslag',
  Selskapet: 'Borettslaget',
} as const
